// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---packages-gatsby-plugin-blocks-src-templates-editor-js": function componentPackagesGatsbyPluginBlocksSrcTemplatesEditorJs() {
    return import("./../../packages/gatsby-plugin-blocks/src/templates/editor.js"
    /* webpackChunkName: "component---packages-gatsby-plugin-blocks-src-templates-editor-js" */
    );
  },
  "component---packages-gatsby-plugin-blocks-src-templates-pages-js": function componentPackagesGatsbyPluginBlocksSrcTemplatesPagesJs() {
    return import("./../../packages/gatsby-plugin-blocks/src/templates/pages.js"
    /* webpackChunkName: "component---packages-gatsby-plugin-blocks-src-templates-pages-js" */
    );
  },
  "component---src-pages-404-mdx": function componentSrcPages404Mdx() {
    return import("./../../src/pages/404.mdx"
    /* webpackChunkName: "component---src-pages-404-mdx" */
    );
  },
  "component---src-pages-about-mdx": function componentSrcPagesAboutMdx() {
    return import("./../../src/pages/about.mdx"
    /* webpackChunkName: "component---src-pages-about-mdx" */
    );
  },
  "component---src-pages-blocks-mdx": function componentSrcPagesBlocksMdx() {
    return import("./../../src/pages/blocks.mdx"
    /* webpackChunkName: "component---src-pages-blocks-mdx" */
    );
  },
  "component---src-pages-blocks-old-js": function componentSrcPagesBlocksOldJs() {
    return import("./../../src/pages/blocks-old.js"
    /* webpackChunkName: "component---src-pages-blocks-old-js" */
    );
  },
  "component---src-pages-confirm-mdx": function componentSrcPagesConfirmMdx() {
    return import("./../../src/pages/confirm.mdx"
    /* webpackChunkName: "component---src-pages-confirm-mdx" */
    );
  },
  "component---src-pages-confirmed-mdx": function componentSrcPagesConfirmedMdx() {
    return import("./../../src/pages/confirmed.mdx"
    /* webpackChunkName: "component---src-pages-confirmed-mdx" */
    );
  },
  "component---src-pages-demo-js": function componentSrcPagesDemoJs() {
    return import("./../../src/pages/demo.js"
    /* webpackChunkName: "component---src-pages-demo-js" */
    );
  },
  "component---src-pages-docs-advanced-blocks-docs-generation-mdx": function componentSrcPagesDocsAdvancedBlocksDocsGenerationMdx() {
    return import("./../../src/pages/docs/advanced/blocks-docs-generation.mdx"
    /* webpackChunkName: "component---src-pages-docs-advanced-blocks-docs-generation-mdx" */
    );
  },
  "component---src-pages-docs-advanced-how-it-works-mdx": function componentSrcPagesDocsAdvancedHowItWorksMdx() {
    return import("./../../src/pages/docs/advanced/how-it-works.mdx"
    /* webpackChunkName: "component---src-pages-docs-advanced-how-it-works-mdx" */
    );
  },
  "component---src-pages-docs-advanced-index-mdx": function componentSrcPagesDocsAdvancedIndexMdx() {
    return import("./../../src/pages/docs/advanced/index.mdx"
    /* webpackChunkName: "component---src-pages-docs-advanced-index-mdx" */
    );
  },
  "component---src-pages-docs-advanced-queries-mdx": function componentSrcPagesDocsAdvancedQueriesMdx() {
    return import("./../../src/pages/docs/advanced/queries.mdx"
    /* webpackChunkName: "component---src-pages-docs-advanced-queries-mdx" */
    );
  },
  "component---src-pages-docs-advanced-transforms-mdx": function componentSrcPagesDocsAdvancedTransformsMdx() {
    return import("./../../src/pages/docs/advanced/transforms.mdx"
    /* webpackChunkName: "component---src-pages-docs-advanced-transforms-mdx" */
    );
  },
  "component---src-pages-docs-controls-mdx": function componentSrcPagesDocsControlsMdx() {
    return import("./../../src/pages/docs/controls.mdx"
    /* webpackChunkName: "component---src-pages-docs-controls-mdx" */
    );
  },
  "component---src-pages-docs-guides-index-mdx": function componentSrcPagesDocsGuidesIndexMdx() {
    return import("./../../src/pages/docs/guides/index.mdx"
    /* webpackChunkName: "component---src-pages-docs-guides-index-mdx" */
    );
  },
  "component---src-pages-docs-guides-write-a-custom-block-mdx": function componentSrcPagesDocsGuidesWriteACustomBlockMdx() {
    return import("./../../src/pages/docs/guides/write-a-custom-block.mdx"
    /* webpackChunkName: "component---src-pages-docs-guides-write-a-custom-block-mdx" */
    );
  },
  "component---src-pages-docs-index-mdx": function componentSrcPagesDocsIndexMdx() {
    return import("./../../src/pages/docs/index.mdx"
    /* webpackChunkName: "component---src-pages-docs-index-mdx" */
    );
  },
  "component---src-pages-getting-started-mdx": function componentSrcPagesGettingStartedMdx() {
    return import("./../../src/pages/getting-started.mdx"
    /* webpackChunkName: "component---src-pages-getting-started-mdx" */
    );
  },
  "component---src-pages-index-mdx": function componentSrcPagesIndexMdx() {
    return import("./../../src/pages/index.mdx"
    /* webpackChunkName: "component---src-pages-index-mdx" */
    );
  },
  "component---src-pages-newsletter-mdx": function componentSrcPagesNewsletterMdx() {
    return import("./../../src/pages/newsletter.mdx"
    /* webpackChunkName: "component---src-pages-newsletter-mdx" */
    );
  },
  "component---src-pages-prior-art-mdx": function componentSrcPagesPriorArtMdx() {
    return import("./../../src/pages/prior-art.mdx"
    /* webpackChunkName: "component---src-pages-prior-art-mdx" */
    );
  },
  "component---src-pages-uses-mdx": function componentSrcPagesUsesMdx() {
    return import("./../../src/pages/uses.mdx"
    /* webpackChunkName: "component---src-pages-uses-mdx" */
    );
  },
  "component---src-pages-vision-mdx": function componentSrcPagesVisionMdx() {
    return import("./../../src/pages/vision.mdx"
    /* webpackChunkName: "component---src-pages-vision-mdx" */
    );
  },
  "component---src-templates-block-js": function componentSrcTemplatesBlockJs() {
    return import("./../../src/templates/block.js"
    /* webpackChunkName: "component---src-templates-block-js" */
    );
  }
};